@if (loaderIcon | async) {
<app-loader></app-loader>
}
<div class="layout-container">
    <app-operations [isCollapsed]="isCollapsed" *ngIf="!hideOpenCashTopMenu"></app-operations>
    <div class="main-content">
        <app-top-bar (toggleSidebar)="handleToggle()" *ngIf="!hideOpenCashTopMenu"></app-top-bar>
        <div class="content-area" [userPermissionHandler]="viewPermissionHandlerData">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="fw-semibold">Opening Cash Drawer Amount</h5>
            </div>
            <hr />
            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-4 text-start mt-2">
                    <div class="container mt-4" style="max-width: 400px;">
                        <div class="card shadow-sm p-4">
                            <div class="mb-3">
                                <label for="pcTerminal" class="form-label">Terminal</label>
                                <select class="form-select" id="pcTerminal" [(ngModel)]="selectedTerminal"
                                    (ngModelChange)="changePOsTerminal($event)" [disabled]="!allowEditOpeningCash">
                                    <option value="null" selected>Select</option>
                                    @for (terminal of posTerminals; track terminal.Id) {
                                    @if (!terminal.InActive) {
                                    <option [value]="terminal.Name">{{ terminal.Name }}</option>
                                    }
                                    }
                                </select>
                            </div>
                            <div class="mb-3">
                                <label for="userName" class="form-label">Current Logged-in User Name</label>
                                <select class="form-select" id="pcTerminal" [(ngModel)]="selectedUser"
                                    [disabled]="!superUser" (ngModelChange)="changeUser($event)">
                                    @for (user of filteredUsersList; track user.UserId) {
                                    <option [value]="user.UserId">{{ user.UserName}}</option>
                                    }
                                </select>
                            </div>
                            <div class="mb-3">
                                <label for="dateTime" class="form-label">Date & Time</label>
                                <ejs-datepicker class="form-control p-0" format="MM/dd/yyyy hh:mm:ss a"
                                    [min]="currentDate" [(ngModel)]="openingDateTime" disabled="true"></ejs-datepicker>
                            </div>
                            <div class="mb-3">
                                <label for="cashDrawer" class="form-label fw-semibold">Opening Cash Drawer
                                    Amount</label>
                                <input type="text" class="form-control text-end" id="cashDrawer"
                                    [(ngModel)]="openingCashDrawerAmount" (change)="changeOpeningCashDrawer()"
                                    (keyup)="changeOpeningCashDrawer()" [appTwoDigitDecimal]='decimalRestrictInput'
                                    [disabled]="previousDayEndNotProcessed || !allowEditOpeningCash">
                            </div>
                            <div class="d-grid">

                                @if (!posOpenCashDetails || posOpenCashDetails?.Id == 0) {
                                <ejs-tooltip id='tipCashDrawSave' target="#btnCashDrawSave" position='LeftCenter'
                                    (beforeOpen)="onBeforeOpen($event)">
                                    <button class="btn btnAS" id="btnCashDrawSave" (click)="saveOpeningCashDrawer()"
                                        [disabled]="!selectedTerminal || selectedTerminal == 'null' || previousDayEndNotProcessed"
                                        [userPermissionHandler]="createPermissionHandlerData">SAVE</button>
                                </ejs-tooltip>
                                } @else {
                                <ejs-tooltip id='tipCashDrawUpdate' target="#btnCashDrawUpdate" position='LeftCenter'
                                    (beforeOpen)="onBeforeOpen($event)">
                                    <button class="btn btnAS" id="btnCashDrawUpdate" (click)="saveOpeningCashDrawer()"
                                        [disabled]="!selectedTerminal || selectedTerminal == 'null' || previousDayEndNotProcessed || !allowEditOpeningCash"
                                        [userPermissionHandler]="editPermissionHandlerData">SAVE</button>
                                </ejs-tooltip>
                                }

                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-8 mt-2">
                    <div class="row">
                        <div class="col-lg-2"></div>
                        <div class="col-md-12 col-lg-10">
                            <div class="form-check mb-3">
                                <input class="form-check-input" type="checkbox" id="coinsBills"
                                    [disabled]="!selectedTerminal || selectedTerminal == 'null' || previousDayEndNotProcessed || !allowEditOpeningCash"
                                    [(ngModel)]="checkCoinsBills" (change)="openCashcheckBox()">
                                <label class="form-check-label" for="coinsBills">
                                    Coins & Bills
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-2"></div>
                        <div class="col-md-12 col-lg-10">
                            <ejs-grid height="310" #gridCoinsBills [dataSource]="listCoinsAndBills">
                                <e-columns>
                                    <e-column field="Name" [isPrimaryKey]=true headerText="Coins / Bills"
                                        width="200"></e-column>
                                    <e-column field="Count" headerText="Count" width="100" textAlign="Center"
                                        editType="numericedit">
                                        <ng-template #template let-data>
                                            <input class="e-field e-ejinputtext form-control form-control-sm d-inline"
                                                style="text-align: center;width:115px;" type='text' maxlength="9"
                                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                [(ngModel)]="data.Count"
                                                [disabled]="!checkCoinsBills || previousDayEndNotProcessed || !allowEditOpeningCash"
                                                (keyup)="calculateTotalCost(data, $event)"
                                                (change)="calculateTotalCost(data, $event)">
                                        </ng-template>
                                    </e-column>
                                    <e-column field="Amount" headerText="Amount" width="150" textAlign="Right"
                                        format="C2" editType="numericedit"></e-column>
                                </e-columns>
                            </ejs-grid>
                            <div class="row mt-2">
                                <div class="col-lg-5"></div>
                                <div class="col-md-6 col-lg-3 text-end">
                                    <label for="ttlAmt" class="form-label fw-semibold mt-1">Total Amount:</label>
                                </div>
                                <div class="col-md-6 col-lg-5 col-xl-4 text-end">
                                    <input type="text" id="ttlAmt" name="ttlAmt" class="form-control text-end me-2"
                                        readonly [value]="gridTotal | currency">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="!hideOpenCashTopMenu">
                <div class="col-12 text-end my-2">
                    <button class="btn btnAS me-1"
                        [disabled]="!this.posOpenCashDetails || this.posOpenCashDetails?.Id == 0 || previousDayEndNotProcessed"
                        (click)="onReportView()">Preview</button>
                    <button class="btn btn-orange" (click)="btnCancel()">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</div>